export const BROWSER_TO_GOOGLE_PLAY: Record<string, string> = {
  en: "en-GB",
  hi: "hi-IN",
  zh: "zh-CN",
  ta: "ta-IN",
  pt: "pt-BR",
  tl: "fil",
  ja: "ja-JP",
  ko: "ko-KR",
  es: "es-ES",
  "es-MX": "es-419",
  "es-AR": "es-419",
  ru: "ru-RU",
  te: "te-IN",
  mr: "mr-IN",
  bn: "bn-BD",
  "bn-IN": "bn-BD",
  kn: "kn-IN",
  ml: "ml-IN",
  az: "az-AZ",
  cs: "cs-CZ",
  da: "da-DK",
  de: "de-DE",
  el: "el-GR",
  eu: "eu-ES",
  fi: "fi-FI",
  fr: "fr-FR",
  gl: "gl-ES",
  he: "iw-IL",
  hu: "hu-HU",
  hy: "hy-AM",
  is: "is-IS",
  it: "it-IT",
  ka: "ka-GE",
  km: "km-KH",
  ky: "ky-KG",
  lo: "lo-LA",
  mk: "mk-MK",
  mn: "mn-MN",
  my: "my-MM",
  ne: "ne-NP",
  nl: "nl-NL",
  no: "no-NO",
  nb: "no-NO",
  nn: "no-NO",
  pl: "pl-PL",
  si: "si-LK",
  sv: "sv-SE",
  tr: "tr-TR",
};
